module.exports = __webpack_public_path__ + "static/rocket-1f90434a8c23b8790c21a22c6f94c4c6.gif";